import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/ServiceDetails.css";
import WhatsAppFloat from "../components/WhatsAppFloat"


function Work() {
  return (
    <div>
      <Navbar />

      <section className="service-detail">

        <h1>Work Sponsorship Visa Services</h1>

        <p className="intro">
          Our agency provides <b>professional and reliable Work Sponsorship Visa services</b> for individuals seeking employment opportunities abroad.
          We help you connect with legitimate employers and guide you through the entire <i>visa sponsorship and immigration process</i>.
        </p>

        <img
          src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=900&auto=format&fit=crop&q=60"
          alt="Work abroad professionals"
          className="service-image"
        />

        <div className="content">

          
          <h2>What is a Work Sponsorship Visa?</h2>
          <p>
            A <b>Work Sponsorship Visa</b> is a type of work permit that allows foreign nationals to work legally for a specific employer in a foreign country.
          </p>

          <p>
            In most cases, the employer must prove that the role cannot be easily filled locally.
            Once approved, the employer becomes your sponsor and supports your visa application.
          </p>

          
          <h2>Our Work Sponsorship Visa Services Include</h2>

          <h3>1. Job Search and Employer Matching</h3>
          <p>
            We assist qualified candidates in finding <b>genuine job opportunities</b> with companies willing to sponsor foreign workers.
            We match your skills and experience with suitable roles across industries.
          </p>

          <h3>2. Employer Sponsorship Guidance</h3>
          <p>
            We guide you on how sponsorship works and connect you with verified employers who are authorized to sponsor work visas.
          </p>

          <h3>3. CV and Resume Optimization</h3>
          <p>
            We improve your CV to meet <i>international hiring standards</i>, increasing your chances of being selected by employers abroad.
          </p>

          <h3>4. Application and Documentation Support</h3>
          <p>We help you prepare all required documents:</p>

          <ul>
            <li>Updated CV / Resume</li>
            <li>International passport</li>
            <li>Academic and professional certificates</li>
            <li>Work experience records</li>
            <li>Reference letters</li>
            <li>Job offer letters (if available)</li>
          </ul>

          <p>
            We ensure all documents meet embassy and employer requirements.
          </p>

          <h3>5. Work Permit and Visa Application Assistance</h3>
          <p>Once you receive a job offer, we guide you through:</p>

          <ul>
            <li>Visa form completion</li>
            <li>Embassy appointment booking</li>
            <li>Document submission</li>
            <li>Visa interview preparation</li>
          </ul>

          <h3>6. Interview Preparation</h3>
          <p>
            We prepare you for both <b>employer and visa interviews</b>, helping you answer questions confidently and professionally.
          </p>

          <h3>7. Relocation Guidance</h3>
          <p>After approval, we assist with relocation planning including:</p>

          <ul>
            <li>Travel arrangements</li>
            <li>Accommodation guidance</li>
            <li>Arrival procedures</li>
            <li>Work environment orientation</li>
          </ul>

          
          <h2>Key Benefits of Our Service</h2>

          <ul>
            <li>Access to verified international job opportunities</li>
            <li>Higher chances of securing employer sponsorship</li>
            <li>Professional CV and job application support</li>
            <li>Step-by-step visa guidance</li>
            <li>Transparent and trusted process</li>
            <li>Full support from application to relocation</li>
          </ul>

          <p>
            We aim to bridge the gap between skilled workers and global employers through a <i>safe, simple, and efficient process</i>.
          </p>

          
          <h2>Popular Work Visa Destinations</h2>

          <ul>
            <li>Canada</li>
            <li>United Kingdom</li>
            <li>United States</li>
            <li>Germany</li>
            <li>Australia</li>
            <li>United Arab Emirates (UAE)</li>
            <li>Ireland</li>
            <li>Netherlands</li>
            <li>Poland and more</li>
          </ul>

          
          <h2>Start Your International Career Today</h2>

          <p>
            If you are ready to take your career global, our <b>Work Sponsorship Visa service</b> is designed to help you get there.
          </p>

          <p>
            We connect you with real opportunities and guide you until you successfully relocate and begin working abroad.
          </p>

          <p>
            <b>Contact us today</b> and start your journey toward international employment!
          </p>

        </div>

      </section>

      <Footer />
      <WhatsAppFloat/>
    </div>
  );
}

export default Work;